import API from "Util/Axios"
import { Button, Card, Progress } from "antd"
import { useEffect, useState } from "react"
import {SyncOutlined} from "@ant-design/icons"

const FileEstadistica=()=>{
    const [cargando,setCargando] = useState(false)
    const [info,setinfo] = useState({})

    const cargar=async ()=>{
        try{
            setCargando(true)
            const {data} = await API('file/disponible')
            setinfo(data)
        }catch(error){

        }finally{
            setCargando(false)
        }
    }

    useEffect(()=>{
        cargar()
    },[])

    return <Card title='Espacio disponible' loading={cargando} actions={[<Button onClick={cargar} icon={<SyncOutlined />}/>]}>
        <Progress  size={32}  percent={((info?.free/(info?.total || 1))*100).toFixed(1)} type="circle" />
        <div>
        {info?.free?.humanFileSize()} de {info?.total?.humanFileSize()}
        </div>
    </Card>
}

export default FileEstadistica